import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnDestroy,
  OnInit,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { NgClass } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { IconComponent } from '@shared/components';
import { slideInAnimation, slideOutAnimation } from '@shared/animations';

import { Toast } from '../models';

@Component({
  selector: 'ui-toast',
  standalone: true,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  animations: [slideInAnimation, slideOutAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslateModule, NgClass],
})
export class ToastComponent implements OnInit, OnDestroy {
  readonly toast = input.required<Toast>();

  readonly closeToast: OutputEmitterRef<void> = output<void>();

  private _intervalId: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    this._intervalId = setInterval(() => this.close(), this.toast().duration);
  }

  ngOnDestroy(): void {
    clearInterval(this._intervalId);
  }

  close(): void {
    this.closeToast.emit();
  }
}
